import { axiosInstance as request } from '@/api/rest.service'
import axios from 'axios'

export const getPublishers = () => request.get('/publishers')
export const getROPublishers = () => request.get('/research-output/publishers')
export const getAllPublishers = () => {
  return axios
    .all([getPublishers(), getROPublishers()])
    .then(axios.spread(({ data: data1 }, { data: data2 }) => ({ data1, data2 })))
}
export const filterData = payload => request.post('/research-output/analysis/filtered-data', payload)
export const analyze = payload => request.post('/research-output/analysis/output', payload)
